import { ISymbolMappingFilterStoreSegment } from './symbolMappingFilter.interface';

export const symbolMappingFilterStoreSelector = (state: ISymbolMappingFilterStoreSegment) => state.symbolMappingFilter;
